import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { BiTrash } from 'react-icons/bi'
import { useDispatch, useSelector } from 'react-redux'
import Modal from './Modal'
import Table from '../../components/Table'
import Confirmation from '../../components/Confirmation/Confirmation'
import Loader from '../../components/Loader'
import { deleteEquipmentGroup, getEquipmentGroups } from '../../actions/equipmentGroups'

export default function EquipmentGroups() {
  const dispatch = useDispatch()
  const { list, loading } = useSelector(state => state.equipment_groups)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false)

  useEffect(() => {
    dispatch(getEquipmentGroups())
  }, [])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    dispatch(deleteEquipmentGroup(confirmation.id))
    setConfirmation(false)
  }

  const rejectConfirmation = () => setConfirmation(false)

  const renderRow = (data) => {
    const { id, groupnum, groupname } = data
    return (
      <tr key={id} onClick={openModal(data)}>
        <td className={styles.tdNum}>{groupnum ?? '—'}</td>
        <td className={styles.tdName}>{groupname}</td>
        <td>
          <button
            type="button"
            className={styles.deleteBtn}
            onClick={(e) => { e.stopPropagation(); setConfirmation({ id, name: groupname }) }}
            title="Удалить запись"
            aria-label="Удалить"
          >
            <BiTrash size={20} />
          </button>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить группу «${confirmation.name}»?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
        />
      }
      <header className={styles.header}>
        <h1>Группы оборудования</h1>
      </header>
      <main className={styles.content}>
        {loading && !list?.length
          ? <Loader />
          : <Table className={styles.table}>
            <thead>
              <tr>
                <th style={{ width: '120px' }}>Номер</th>
                <th className={styles.thName}>Название</th>
                <th style={{ width: '70px' }}>Удалить</th>
              </tr>
            </thead>
            <tbody>
              {list?.length
                ? list.map(renderRow)
                : <tr><td className={styles.emptyRow} colSpan={3}>Нет записей</td></tr>}
            </tbody>
          </Table>
        }
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего: {list?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
